export const HOURS_IN_DAY = 24
export const DAYS_IN_WEEK = 7
export const TUBE_ITEM_HEIGHT = 22
